import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { TopBar, OfferBar } from './components/Countdown';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { QuickTestimonials } from './components/QuickTestimonials';
import { Problems } from './components/Problems';
import { SystemOverview } from './components/SystemOverview';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Comparison } from './components/Comparison';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full bg-cream font-body text-body" data-id="element-0" data-mp="23u9tmmkgrbwr">
      <MetaPixel data-id="element-1" data-mp="3ijxpqrsp22kf" />
      <TopBar data-id="element-2" data-mp="3ikh8ubu2yx01" />
      <main data-id="element-3" data-mp="3ikqwvtvkeu33">
        <Hero data-id="element-4" data-mp="3ij63w8owfj7c" />
        <Stats data-id="element-5" data-mp="3ijpbowku4r7n" />
        <QuickTestimonials data-id="element-6" data-mp="3ihuyk4ft23e4" />
        <Problems data-id="element-7" data-mp="3mlat8v8bdto6" />
        <SystemOverview data-id="element-8" data-mp="3mkrgru1fnxhj" />
        <Modules data-id="element-9" data-mp="3mjztr7lwj82v" />
        <Bonuses data-id="element-10" data-mp="3mjg93j4va5l5" />
        <OfferBar data-id="element-11" data-mp="3rc9ca2kot5v4" />
        <Pricing data-id="element-12" data-mp="3rbrc4uuwm7hx" />
        <Testimonials data-id="element-13" data-mp="3rdarmj8qkein" />
        <Guarantee data-id="element-14" data-mp="3rd1all5o5hp3" />
        <Faq data-id="element-15" data-mp="3relvej26lm9r" />
        <Comparison data-id="element-16" data-mp="5osn3wyp084" />
        <FinalCta data-id="element-17" data-mp="67yvnd9206b" />
      </main>
      <Footer data-id="element-18" data-mp="5ghbgghm2z1" />
      <PurchasePopup data-id="element-19" data-mp="82kl3wchwbg" />
    </div>;
}